"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var i18next_1 = __importDefault(require("i18next"));
var ConfigOption_1 = __importStar(require("../../../../widgets/ConfigOption"));
var index_1 = require("../../index");
var shortlink_1 = __importDefault(require("../util/shortlink"));
var Tooltip_1 = __importDefault(require("../../../../widgets/Tooltip"));
var PrefixableTextField_1 = __importDefault(require("../../../../widgets/PrefixableTextField"));
var TrailingButton_1 = __importDefault(require("./TrailingButton"));
var LinkOwnershipField = function (_a) {
    var closeModal = _a.closeModal;
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var drawerStates = index_1.useDrawerState();
    var shortLinkDispatch = shortlink_1.default(drawerStates.relevantShortLink).shortLinkDispatch;
    var _b = __read(react_1.useState(''), 2), pendingOwner = _b[0], setPendingOwner = _b[1];
    var linkOwnershipHelp = (react_1.default.createElement(react_1.default.Fragment, null,
        "Link owner",
        ' ',
        react_1.default.createElement(Tooltip_1.default, { title: "Links can only be transferred to an existing " + i18next_1.default.t('general.appTitle') + " user", imageAltText: "Ownership help" })));
    return (react_1.default.createElement(ConfigOption_1.default, { title: linkOwnershipHelp, leading: react_1.default.createElement(PrefixableTextField_1.default, { value: pendingOwner, onChange: function (event) { return setPendingOwner(event.target.value); }, placeholder: "Email of link recipient", helperText: ' ' }), trailing: react_1.default.createElement(TrailingButton_1.default, { onClick: function () {
                shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.applyNewOwner(pendingOwner, closeModal);
            }, disabled: !pendingOwner, variant: isMobileView ? 'contained' : 'outlined', fullWidth: isMobileView }, "Transfer"), wrapTrailing: isMobileView, trailingPosition: ConfigOption_1.TrailingPosition.end }));
};
exports.default = LinkOwnershipField;
